import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DocumentIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.44444 12H15.1111M8.44444 16.4444H15.1111M17.3333 22H6.22222C5.63285 22 5.06762 21.7659 4.65087 21.3491C4.23413 20.9324 4 20.3671 4 19.7778V4.22222C4 3.63285 4.23413 3.06762 4.65087 2.65087C5.06762 2.23413 5.63285 2 6.22222 2H12.4289C12.7235 2.00006 13.0061 2.11717 13.2144 2.32556L19.23 8.34111C19.4384 8.54944 19.5555 8.83201 19.5556 9.12667V19.7778C19.5556 20.3671 19.3214 20.9324 18.9047 21.3491C18.4879 21.7659 17.9227 22 17.3333 22Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

DocumentIcon.displayName = 'DocumentIcon';
